import api from '@/api/fyApi';
import BaseModule from "@/common/BaseModule";
import { Module } from "vuex";
import { LOAD_GOSPEL_HOME, LOAD_GOSPEL_CATEGORY, SEO } from '../protocols';
import home from './home'

export interface State {
    page: number,
    size: number,
    total: number,
    list: Array<{
        "id": number,
        "category_id": number,
        "title": string,
        "thumb": string,
        "author": string,
        "intro": string,
        "level": number,
        "listorder": number,
        "status": number,
        "hits": number,
        "items": number,
        "createtime": number,
        "updatetime": number,
    }>
}

class GospelCategory extends BaseModule<State> {
    constructor() {
        super(LOAD_GOSPEL_CATEGORY[0])
    }
    generate(): Module<State, any> {
        return {
            namespaced: true,
            state: {
                list: [],
                page: 1,
                size: 100,
                total: 0,
            },
            actions: {
                async loadData({ state, dispatch, commit, rootState }, route: Route) {
                    let id = parseInt(route.params.id)
                    let page = parseInt(route.query.page) || 1
                    let r = await api.getGospelBooks(id, page, state.size)
                    state.total = r.count
                    state.list = r.list

                    const title = rootState[home.name].menu.find((item: any) => item.id == id)
                    if (title) {
                        const seoTitle = `福音信息-${title.name}-福音影视网|福音TV`
                        commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    }
                },
                [LOAD_GOSPEL_CATEGORY[1]]({ dispatch, commit }, route: Route) {
                    const seoTitle = '福音信息-一起看-福音影视网|福音TV'
                    commit('updateSeo', Object.assign({}, SEO, { title: seoTitle }), { root: true })
                    return Promise.all([
                        dispatch('loadData', route),
                        dispatch(LOAD_GOSPEL_HOME[0] + '/loadCategory', route, { root: true })
                    ])
                }
            }
        }
    }
}

export default new GospelCategory();